import { gql } from '@apollo/client'

export const getRegion = gql`
  query Region($id: ID!) {
    region(id: $id) {
      id
      name
      timezone
      resource_confirm_details
      resource_instruction
    }
  }
`

export const getAllRegion = gql`
  query Regions {
    regions {
      id
      name
      timezone
      is_available
    }
  }
`
